export * from './negocios-fuente-icon.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/negocios/negocios-fuente-icon/index.ts